<template>
  <div class="content-sql">
    <textarea
      v-model="sql"
      placeholder="select * from employees"
      @keypress.enter.prevent="generateReport"
    />
    <div>
      <custom-button
        :size="'small'"
        :title="'Generuj raport'"
        class="btn btn-sm ml-1 generate-button mt-2"
        variant="outline-primary"
        @click="generateReport"
      />

      <custom-button
        :size="'small'"
        :title="'Pobierz raport'"
        class="btn btn-sm ml-1 generate-button mt-2"
        variant="outline-primary"
        @click="generateReportXLSX(sql)"
      />
    </div>

    <div class="save-report-content" v-if="lastSqlQuery">
      <dod-custom-input
        type="text"
        :prePickedValue="reportName"
        @onType="(e) => (reportName = e)"
        :customPlaceholder="'Podaj nazwę raportu'"
        class="save-report-content-input"
      />
      <custom-button
        :size="'small'"
        :title="'Zapisz raport'"
        class="btn btn-sm ml-1 generate-button mt-2"
        variant="outline-primary"
        @click="saveReport"
      />
    </div>
    <table
      class="table align-middle table-response"
      v-if="reportRows && reportRows.length > 0"
    >
      <thead>
        <tr>
          <td v-for="column of reportColumns" :key="column">{{ column }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) of reportRows" :key="row.id || index">
          <td v-for="key in reportColumns" :key="key">{{ row[key] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CustomButton from "../CustomButton.vue";
import DodCustomInput from "./DodCustomInput.vue";

export default {
  components: { CustomButton, DodCustomInput },
  name: "DodGenerateSQL",
  data: () => {
    return {
      sql: "",
      reportRows: [],
      reportColumns: [],
      reportName: "",
      lastSqlQuery: "",
    };
  },

  methods: {
    async saveReport() {
      if (!this.reportName) {
        this.$notify({
          group: "error",
          text: "Podaj nazwę raportu",
        });
        return;
      }

      const response = await this.$store.dispatch("saveSqlReport", {
        query: this.lastSqlQuery,
        title: this.reportName,
      });
      if (response) {
        this.$notify({
          group: "success",
          text: "Raport został zapisany",
        });
      }
    },
    async generateReport() {
      if (!this.sql) {
        this.$notify({
          text: `Wprowadź zapytanie SQL`,
          group: "error",
        });

        return;
      }

      try {
        await this.$store.dispatch("generateDodSqlReport", { sql: this.sql });
        if (this.sqlReport && this.sqlReport[0]) {
          this.reportColumns = Object.keys(this.sqlReport[0]);
          this.reportRows = this.sqlReport;
          this.lastSqlQuery = this.sql;
        }
        if (this.sqlReport && this.sqlReport.length === 0) {
          this.$notify({
            text: `Brak wyników`,
            group: "error",
          });
        }
      } catch (error) {
        this.$notify({
          text: `Nie udało się wykonać zapytania. Sprawdź czy zapytanie jest na pewno bez żadnych błędów`,
          group: "error",
        });
        this.reportColumns = [];
        this.reportRows = [];
      }
    },

    async generateReportXLSX(sql) {
      try {
        const params = new URLSearchParams();
        params.append("sql", sql);
        const response = await this.$store.dispatch(
          "generateDodSqlReportXLSX",
          {
            sql: sql,
          }
        );
        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "raport.xls");
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          text: `Nie udało się pobrać raportu`,
          group: "error",
        });
      }
    },
  },

  async created() {},

  watch: {
    sql() {
      if (this.sql) {
        const sqlLowerCase = this.sql.toLowerCase();
        const forbiddenKeywords = [
          "alter",
          "delete",
          "update",
          "insert",
          "drop",
          "truncate",
          "grant",
          "revoke",
        ];
        const regex = new RegExp(
          `\\b(${forbiddenKeywords.join("|")})\\b`,
          "gi"
        );

        if (sqlLowerCase.match(regex)) {
          this.$notify({
            text: `Zapytanie zawiera niedozwolone słowo kluczowe`,
            group: "error",
          });

          this.sql = this.sql.replace(regex, "");
        }
      }
    },
  },

  computed: {
    sqlReport() {
      return this.$store.getters.getDodSqlReport;
    },
  },
};
</script>

<style scoped>
.content-sql {
  width: 100%;
  margin-bottom: 5rem;
  display: flex;
  flex-direction: column;
}
textarea {
  width: 70%;
  text-align: center;
  padding: 1rem;
}
.generate-button {
  width: 70%;
}
.table-response {
  margin-top: 3rem;
}
.save-report-content {
  margin-top: 2rem;
}
.save-report-content-input {
  width: 70%;
}
</style>
